import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const NewPreLiquidationPage = lazy(() => import('../../../pages').then(module => ({default: module.NewPreLiquidationPage})));
const SavedAndSentPreLiquidationsPage = lazy(() => import('../../../pages').then(module => ({ default: module.SavedAndSentPreLiquidationsPage })))

export const preliquidationChildrenRoutes = [
  {
    path: '',
    element: <Navigate to={'preliquidacion'} />,
  },
  {
    path: 'preliquidacion',
    element: <NewPreLiquidationPage />,
  },
  {
    path: 'preliquidacion/:id',
    element: <NewPreLiquidationPage />,
  },
  {
    path: 'preliquidaciones-guardadas',
    element: <SavedAndSentPreLiquidationsPage />
  }
];
